/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_DavidInputs */

const en_onboarding_rating_david = /** @type {(inputs: Onboarding_Rating_DavidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This works surprisingly well - minimalistic app but the magic is in the background. Share PDFs to it and listen while taking a walk! Ideal for me.`)
};

const es_onboarding_rating_david = /** @type {(inputs: Onboarding_Rating_DavidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto funciona sorprendentemente bien - app minimalista pero la magia está en el fondo. ¡Comparte PDFs y escucha mientras caminas! Ideal para mí.`)
};

/**
* | output |
* | --- |
* | "This works surprisingly well - minimalistic app but the magic is in the background. Share PDFs to it and listen while taking a walk! Ideal for me." |
*
* @param {Onboarding_Rating_DavidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_david = /** @type {((inputs?: Onboarding_Rating_DavidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_DavidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_david(inputs)
	return en_onboarding_rating_david(inputs)
});